// TODO(RBAC, parent #641 #647): admin only
import { createConnectQueryKey } from '@connectrpc/connect-query'
import { listWorkflowTagPool } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'
import {
  deleteWorkflowTemplate,
  getWorkflowTemplateFormOptions,
  listWorkflowTemplates,
} from '@ebalance/proto/bffuser/v1/workflow_template_service-WorkflowTemplateService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * ワークフロー雛形削除 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useDeleteWorkflowTemplate(): InvalidatingMutationResultFor<
  typeof deleteWorkflowTemplate
> {
  return useInvalidatingMutation(deleteWorkflowTemplate, [
    createConnectQueryKey({
      schema: listWorkflowTemplates,
      cardinality: 'finite',
    }),
    // 雛形削除は org 全体のタグプール (AC-TAG-005) を縮小しうる (AC-TAG-007: 参照 0 件で
    // プールから消滅) ため、他画面のサジェスト・20 個上限チェックを最新化する。
    createConnectQueryKey({
      schema: listWorkflowTagPool,
      cardinality: 'finite',
    }),
    // workflow-template-form-options-bff-aggregation design: editor 自身が
    // 使う集約 query (`getWorkflowTemplateFormOptions`) の tag_pool 投影も
    // 同じ理由で invalidate する (旧 key は他画面 consumer が使うため残置)。
    createConnectQueryKey({
      schema: getWorkflowTemplateFormOptions,
      cardinality: 'finite',
    }),
  ])
}
